/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>活码列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="margin-top: 1rem;font-size: 0.75em;color:#FF0000">米粒管理|禁止发布违法、违规信息，重点打击诈骗、流量造假、黑公关、网络水军等，发现将封号处理，严重者将移交相关司法部门！谢谢大家支持！</div>
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.qr_title" placeholder="输入活码标题"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60">
      </el-table-column>
      <el-table-column prop="qr_title" label="标题" width="360">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="10">
              <vue-qr
              :text="kefumaUrl(scope.row.qr_id)"
              :size="300"
              :margin="10">
              </vue-qr>
              <!-- <el-image
                style="width: 100px; height: 100px"
                :src="url"
                fit="fill"></el-image> -->
            </el-col>
            <el-col :span="14">
              <p>标题：{{scope.row.qr_title}}</p>
              <el-button size="mini" icon="el-icon-edit" @click="gotourl(scope.$index, scope.row,'编辑活码')">编辑</el-button>
              <div style="margin-top: 1rem;">活码类型：{{qrtype(scope.row.type)}}</div>
            </el-col>
          </el-row>
        </template>
        </el-table-column>
      <el-table-column label="状态" align="center" min-width="100">
        <template slot-scope="scope">
          <!-- <div>{{scope.row.qr_status == 1 ? '正常' : '暂停'}}</div> -->
          <div>创建时间</div>
          <div>{{scope.row.qr_create_time?scope.row.qr_create_time.slice(0,10):""}}</div>
          <div>更新时间</div>
          <div>{{scope.row.qr_update_time?scope.row.qr_update_time.slice(0,10):""}}</div>
        </template>
      </el-table-column>
      <el-table-column label="扫码数据" min-width="120">
        <template slot-scope="scope">
           <div>总访问量：{{scope.row.qr_fwl}}</div>
           <div>总识别量：{{scope.row.qr_sbl}}</div>
           <div>今日访问量：{{scope.row.jrfwl}}</div>
           <div>今日访问人数：{{scope.row.jrfwrc}}</div>
        </template>
      </el-table-column>
      <el-table-column label="活码网址" align="center" min-width="100">
        <template slot-scope="scope">
          <div>活码二维码</div>
          <div>请右击保存</div>
          <el-button size="mini" type="primary" @click="copy(scope.row.qr_id)">一键复制</el-button>
        </template>
      </el-table-column>
      <!-- <el-table-column sortable prop="editTime" label="修改时间" width="300">
        <template slot-scope="scope">
          <div>{{scope.row.editTime|timestampToTime}}</div>
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-row :gutter="20">
            <el-col :span="24"><el-button size="mini" type="primary" icon="el-icon-s-grid" @click="gotourl(scope.$index, scope.row,'子码列表')">子码管理</el-button></el-col></el-row>
            <el-row :gutter="20" class="czbutton">
            <el-col :span="24"><el-button size="mini" type="primary" plain icon="el-icon-s-data" @click="gotourl(scope.$index, scope.row,'统计分析')">数据统计</el-button></el-col></el-row>
            <el-row :gutter="20"><el-col :span="24"><el-button size="mini" type="danger" icon="el-icon-delete" @click="deleteWx(scope.$index, scope.row)">删除活码</el-button></el-col></el-row>

        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import vueQr  from 'vue-qr'
import { qrList, qrSave, qrDelete, getYuming } from '../../api/userMG'
import Pagination from '../../components/Pagination'
import base64 from 'base-64'
export default {
  data() {
    return {
      rukouurl: '', //入口网址
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: '添加',
      editForm: {
        id: '',
        qr_title: '',
        remark: ''
      },
      // rules表单验证
      rules: {
        qr_title: [
          { required: true, message: '请输入活码标题', trigger: 'blur' }
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        qr_title: ''
      },
      // 删除部门
      seletedata: {
        ids: ''
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination, vueQr
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    window.myData = this
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取客服码列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      qrList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
            if(res.msg == '登录过期' || res.msg == '令牌过期'){
              this.$store.commit('logout', 'false')
              this.$router.push({ path: '/login' })
            }
          } else {
            this.listData = res.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total =  parseInt(res.count)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        }),
        getYuming()
          .then(res => {
            if (res.code == 1) {
              this.rukouurl = res.data['rukou'];
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('入口域名获取失败，请稍后再试！')
          })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 删除公司
    deleteWx(index, row) {
      this.$confirm('确定要删除吗?删除后信息不可恢复', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          qrDelete(row.qr_id)
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  type: 'success',
                  message: '客服码已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('客服码删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    //跳转页面
    gotourl(index, row, urlname) {
      this.$router.push({ name: urlname, params: {qr_id: row.qr_id, qr_type: row.type} })
    },
    //生成客服码url
    kefumaUrl(id) {
      let qr_id = base64.encode( (Number(id) + 122) * 5 + 200002 )
      return this.rukouurl + '/m/'+ qr_id
    },
    copy(id){
      let _that = this
      let url = _that.kefumaUrl(id)

      _that.$copyText(url).then(function (e) {
          _that.$message({
            message: '复制成功',
            type: 'success'
          });
        }, function (e) {
          _that.$message.error('复制失败');
          console.log(e)
        })
    },
    qrtype(type) {
      switch(type) {
        case "1":
        return "客服码"
        break
        case "2":
        return "群活码"
        break
        case "3":
        return "链接码"
        break
        case "4":
        return "文档码"
        break
        case "5":
        return "口令码"
        break
        case "6":
        return "分组码"
        break
        default:
        return "未知"
      }
    }
  },
  //计算属性
  computed:{

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.czbutton {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/views/huoma/Qrcode.vue